angular.module('bribac.views.login', [
  'ngRoute',
  'bribac.translations',
  'bribac.services.routeAuth',
  'bribac.values'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/login', {
      templateUrl: 'login-view.html',
      controller: 'LoginViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireUnauth()}}
    })
  })

  .controller('LoginViewCtrl', function (
    ROLES,
    $location,
    availableLocales,
    getCurrentLocale,
    setLocale,
    api,
    VERIFICATION_CODE_REGEX
  ) {

    var $ctrl = this

    $ctrl.mfaSessionId = null
    $ctrl.mfaCode = ''

    // Mfa is enabled by default.
    // If set to false, user just requested to enroll into mfa authorization.
    $ctrl.mfaEnabled = true
    $ctrl.mfaInProgress = false
    $ctrl.REGEX = VERIFICATION_CODE_REGEX

    $ctrl.availableLocales = Object.keys(availableLocales)
    $ctrl.getCurrentLocale = getCurrentLocale
    $ctrl.setLocale = setLocale

    $ctrl.credentials = {
      username: '',
      password: '',
      rememberMe: true,
    }

    $ctrl.onSubmit = function() {
      var $form = $ctrl.form

      // check for mfaInProgress to prevent second submit of form
      if ($form.$invalid || $ctrl.mfaInProgress) {
        return
      }

      $form._submitting = true
      $form._submitError = ''

      api.login($ctrl.credentials)
        .finally(function() {
          $form._submitting = false
        })
        .then(
          function success(response) {
            if (response.data.roles[0] === ROLES.SUBJECT) {
              $ctrl.form._submitError = 'formErrors.subjectLoginError'
            } else {
              $ctrl.mfaInProgress = true
              $ctrl.mfaSessionId = response.data.mfa_session_id
            }
          },
          $ctrl.errorCallback
        )
    }

    $ctrl.backToLogin = function() {
      $ctrl.mfaInProgress = false
    }

    $ctrl.mfaSubmit = function() {
      var $mfaForm = $ctrl.mfaForm

      if ($mfaForm.$invalid) {
        return
      }

      $mfaForm._submitting = true
      $mfaForm._submitError = ''

      if ($ctrl.mfaEnabled) {
        api.mfaCode({
          username: $ctrl.credentials.username,
          code: $ctrl.mfaCode,
          sessionId: $ctrl.mfaSessionId
        })
        .finally($ctrl.finCallback).then($ctrl.successCallback, $ctrl.errorCallback)
      } else {
        api.meMfa({
          mfaCode: $ctrl.mfaCode,
          mfaSessionId: $ctrl.mfaSessionId,
          enabled: true
        })
        .finally($ctrl.finCallback).then($ctrl.successCallback, $ctrl.errorCallback)
      }
    }

    $ctrl.finCallback = function() {
      $ctrl.mfaForm._submitting = false
    }

    $ctrl.successCallback = function (response) {
      if (response.data && response.data.roles[0] === ROLES.SUBJECT) {
        $ctrl.mfaForm._submitError = 'formErrors.subjectLoginError'
      } else {
        $ctrl.continue(response)
      }
    }

    $ctrl.errorCallback = function(request) {
      var requestUrl = request.config.url
      var isLoginRequest = requestUrl.indexOf('/login') !== -1
      var isMfaCodeRequest = requestUrl.indexOf('/mfaCode') !== -1
      var form
      if (isLoginRequest) {
        form = $ctrl.form
      } else if (isMfaCodeRequest) {
        form = $ctrl.mfaForm
      }

      if (!form)
        return

      if (request.statusText && request.statusText !== "") {
        form._submitError = request.statusText
      } else if (request.status && request.status === 401) {
        form._submitError = 'formErrors.unauthorized'
      } else {
        form._submitError = 'formErrors.unknownError'
      }

    }

    $ctrl.continue = function(response) {
      if ($ctrl.mfaEnabled && $ctrl.mfaSessionId) {
        api.finishLogin(response).then($location.path('/'))
      } else {
        api.loadDataAfterAuthSuccess().then($location.path('/'))
      }
    }

    $ctrl.enableMfa = function() {
      api.meMfa({ requesting: true})
      .then(
        function success(response) {
          $ctrl.mfaEnabled = false
          $ctrl.mfaSessionId = response.data.mfaSessionId
        },

        function error(request) {
          $ctrl.failedToEnableMfa = true
        }
      )
  }
})
